import classNames from 'classnames';
import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import {
  InteractiveBadge,
  InteractiveBadgeProps,
} from 'bones/design-system/components/badge/InteractiveBadge';
import { Heading } from 'bones/design-system/components/typography/Heading';

export interface VoiceboxPanelProps {
  actions?: React.ReactNode;
  badges?: Array<Omit<InteractiveBadgeProps, 'size'> & { key?: string }>;
  breadcrumb?: React.ReactNode;
  children?: React.ReactNode;
  slot?: React.ReactNode;
  className?: string;
  title: string;
}

export const VoiceboxPanel: React.VFC<VoiceboxPanelProps> = ({
  actions,
  badges,
  breadcrumb,
  children,
  className,
  slot,
  title,
}) => {
  const { testIds } = useVoiceboxSchema();

  return (
    <div className={classNames(className, 'vb-voicebox-panel')}>
      <div className="vb-voicebox-panel-header">
        {breadcrumb}
        <div className="vb-voicebox-panel-header-title">
          <div className="vb-voicebox-panel-header-text">
            <Heading size="lg" testId={testIds.panel.header.title}>
              {title}
            </Heading>
            <div className="vb-voicebox-panel-header-badges">
              {badges?.map(({ key, ...badgeProps }) => (
                <InteractiveBadge
                  key={key || /* istanbul ignore next */ badgeProps.testId}
                  size="lg"
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...badgeProps}
                />
              ))}
            </div>
          </div>
          <div className="vb-voicebox-panel-header-actions">{actions}</div>
        </div>
      </div>
      <div className="vb-voicebox-panel-content">
        <div className="vb-voicebox-panel-scroll">
          <div className="vb-voicebox-panel-body">{children}</div>
        </div>
        {slot}
      </div>
    </div>
  );
};
